import {mapActions} from "vuex";

export default {
    props:['orderId'],
    data(){
        return{
            receipts: [],
            loading: true,
        }
    },
    created() {
        this.loadReceipts().then(() => {});
    },
    methods:{
        receiptTypeLabel(type) {
            const normalized = String(type).toLowerCase();
            if (normalized === 'sale' || normalized === 'sell') {
                return 'Продаж';
            }
            if (normalized === 'refund' || normalized === 'return') {
                return 'Повернення';
            }
            return 'Невідомий тип';
        },
        receiptTypeClass(type) {
            const normalized = String(type).toLowerCase();
            if (normalized === 'sale' || normalized === 'sell') {
                return 'badge-success';
            }
            if (normalized === 'refund' || normalized === 'return') {
                return 'badge-danger';
            }
            return 'badge-secondary';
        },
        receiptStatusLabel(status) {
            if (!status) {
                return 'Створено';
            }
            const normalized = String(status).toLowerCase();
            const statusMap = {
                created: 'Створено',
                pending: 'Очікує',
                processing: 'Обробляється',
                done: 'Завершено',
                completed: 'Завершено',
                success: 'Успішно',
                error: 'Помилка',
                failed: 'Помилка',
                canceled: 'Скасовано',
                cancelled: 'Скасовано',
            };
            return statusMap[normalized] || status;
        },
        async loadReceipts(){
            this.loading = true;
            const res = await this.getReceiptsByOrder(this.orderId);
            if (res.status) {
                this.receipts = res.data || [];
            } else {
                this.receipts = [];
            }
            this.loading = false;
        },
        closePopup(){
            this.$emit('closePopup');
        },
        ...mapActions({
            getReceiptsByOrder:'checkbox/getReceiptsByOrder',
        })
    },
    destroyed() {
        this.receipts = [];
    }
}
